import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust, heroSeals } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-71" data-mp="9lv00naxu9u9">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      backgroundColor: "#FCF9F9",
      backgroundImage: "none",
      paddingTop: "0px",
      marginTop: "0px",
      marginBottom: "0px"
    }} data-id="element-72" data-mp="4lyuukqi8cd4">
        

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "Montserrat, sans-serif",
        fontWeight: "800",
        paddingTop: "5px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-73" data-mp="x9uqdm4c7y8b">
          Stop the Hot Flashes & Insomnia Tonight. Master Your Hormones in 30 Days.
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px",
        fontWeight: "700",
        textAlign: "center"
      }} data-id="element-74" data-mp="382ff5o82r4ex">
          The Science-Backed Visual Protocol to Cool Your Body, Clear Brain Fog, and Reclaim Your Vitality—Naturally
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-75" data-mp="399tex5kgwudx">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-76" data-mp="358rdqj6zq89b" />
          <img src="https://cdn.magicpatterns.com/uploads/uHd9CXqo5aMWZtNyPPsev7/ChatGPT_Image_13_sept_2026,_12_22_48.png" alt="Mature, radiant woman holding The MenoReset System — the complete natural hormone harmony system" width={1500} height={1000} className="animate-floaty mx-auto aspect-[3/2] w-full max-w-full rounded-2xl object-cover" data-id="element-77" data-mp="2qkwhwtxorns0" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-78" data-mp="s1rqqjt21ys6">
          ⭐ 4.9 (500+ satisfied women who reclaimed their lives) · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-79" data-mp="deq8aed7t21z">
          <CTAButton href="#checkout-card" data-id="element-80" data-mp="1b1fez1iv42u6">See the MenoReset system now</CTAButton>

          <ul aria-label="Product qualities" className="mt-5 grid w-full max-w-md grid-cols-3 gap-2" data-id="element-81" data-mp="1622irq63pjex">
            {heroSeals.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex flex-col items-center gap-1.5" data-id="element-82" data-mp="114swgje0dnvb">
                <span className="flex h-11 w-11 items-center justify-center rounded-full border-2 border-grape-soft bg-white ring-4 ring-lilac-soft" aria-hidden="true" data-id="element-83" data-mp="x0l50eg61tte">
                  <Icon className="h-5 w-5 text-grape" strokeWidth={2} data-id="element-84" data-mp="3hr3sxz3awh7e" />
                </span>
                <span className="text-center text-[10px] font-bold uppercase leading-tight tracking-wide text-plum/70" data-id="element-85" data-mp="1x9ukuaytndnf">
                  {label}
                </span>
              </li>)}
          </ul>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-86" data-mp="269r4tza9noc5">
            COMPLETE HORMONE RESET COMBO 2026. The #1 system for women experiencing peri-menopause,
            menopause, and post-menopause who need a real, natural, and ready-to-use professional
            protocol to balance their bodies.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-87" data-mp="2kx2h63e9vcdb">
            Hot Flashes · Insomnia · Brain Fog · Metabolism · Mood Swings · Longevity
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-88" data-mp="zlausdxjwst9">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center justify-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-center text-xs font-semibold text-plum/80" style={{
            width: "155px",
            height: "31px"
          }} data-id="element-89" data-mp="4a2s9dsxexwg">
                <Icon className="h-3.5 w-3.5 shrink-0 text-grape" data-id="element-90" data-mp="99xnftjqi9nb" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-91" data-mp="3hr27c73lmquy">
            6 Tomes + 3 Free Bonuses · 150+ pages - Everything you need in one place.
          </p>
        </div>

        

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/30 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-92" data-mp="3rh56kp1bd11q">
          🔥 Limited-time offer · Then the price goes back up to $38 USD
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-93" data-mp="19guasiz0a0q1">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-94" data-mp="zkhgbivmziu8" />
          5 people are securing this system right now
        </p>
      </div>
    </header>;
}